import { render, staticRenderFns } from "./KT-Dashboard.vue?vue&type=template&id=6e6052e0&scoped=true&lang=pug&"
import script from "./KT-Dashboard.vue?vue&type=script&lang=js&"
export * from "./KT-Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./KT-Dashboard.vue?vue&type=style&index=0&id=6e6052e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6052e0",
  null
  
)

export default component.exports